import React from "react";

// Calcite Components
import Select from "calcite-react/Select";
import ClearIcon from "calcite-ui-icons-react/XCircleIcon";

import Context from "../../../context/Context";
import QueryCriteria from "../../base/QueryCriteria";
import Topic from "../../../context/Topic";
import * as component from "../../../components/util/component";
import * as filterUtil from "./filterUtil";
import * as selectionUtil from "../../../aiim/util/selectionUtil";

// Syled-Components
import {
  LabelGroup,
  ClearButton,
  SelectGroup,
  MenuItem
} from "../../styles/Filter/filterGroup";

export default class FilterGroup extends React.Component {
  applyLocalFilter = true;

  constructor(props) {
    super(props);
    this.state = component.newState({
      fieldName: this.props.pair.field,
      fieldValue: this.props.pair.value,
      values: null
    });
  }

  clear = () => {
    this.onChange(undefined);
  };

  componentDidMount() {
    if (this.state.fieldName) {
      this.queryUniqueValues(this.state.fieldName);
    }

    component.own(this, [
      Topic.subscribe(Topic.FilterValueSelected, params => {
        if (params.queryCriteriaKey === this.props.queryCriteriaKey) {
          const fieldName = this.props.pair.field;
          this.queryUniqueValues(fieldName);
          // if (fieldName !== params.fieldName) {
          //   this.queryUniqueValues(fieldName);
          // }
        }
      })
    ]);
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  getQueryCriteria() {
    return QueryCriteria.get(this.props.queryCriteriaKey);
  }

  onChange = value => {
    this.setState({
      fieldValue: value
    });
    if (typeof this.props.onChange === "function") {
      const id = this.props.pair.id;
      const fieldName = this.props.pair.field;
      this.props.onChange(id, fieldName, value);
    }
  };

  queryUniqueValues(fieldName) {
    const queryCriteria = this.getQueryCriteria();
    const source = queryCriteria && queryCriteria.getSource();
    const layer = source && source.layer2D;
    const fields = layer && layer.fields;
    const field = filterUtil.getField(fields, fieldName);
    if (!field) return;

    const pairs = queryCriteria._localPairs;
    let where = selectionUtil.getBaseDefinitionExpression(layer);
    if (this.applyLocalFilter) {
      let part = queryCriteria.makeFilterPart(source, pairs, fieldName);
      if (part && part.length > 0) {
        if (typeof where !== "string") where = "";
        if (where.length > 0) where += " AND ";
        where += "(" + part + ")";
      }
    }

    const options = {
      source: source,
      field: field,
      fieldName: fieldName,
      where: where
    };
    filterUtil
      .queryUniqueValues(options)
      .then(values => {
        this.setState({
          values: values
        });
      })
      .catch(ex => {
        console.error(ex);
      });
  }

  renderClearButton() {
    const i18n = Context.instance.i18n;

    // If there is a value in the Select then render the clear button
    if (this.state.fieldValue) {
      return (
        <ClearButton
          iconButton
          icon={<ClearIcon size={16} />}
          title={i18n.filter.clearPart}
          onClick={this.clear}
        />
      );
    }

    // don't render anything if no Select value
    return;
  }

  render() {
    const i18n = Context.instance.i18n;
    const name = this.props.pair.label;
    const values = this.state.values;
    const selectedValue = this.state.fieldValue;

    const menuItems = [];
    if (Array.isArray(values)) {
      values.forEach(info => {
        const v = info.value;
        const s = info.name || v;
        menuItems.push(
          <MenuItem key={v} value={v}>
            {s}
          </MenuItem>
        );
      });
    }

    return (
      <SelectGroup>
        <LabelGroup>
          <label>{name}</label>
          {this.renderClearButton()}
        </LabelGroup>

        <Select
          fullWidth
          placeholder={i18n.filter.valuePrompt}
          selectedValue={selectedValue}
          onChange={this.onChange}
        >
          {menuItems}
        </Select>
      </SelectGroup>
    );
  }
}
